/**
 * オンボーディングページ - テナント作成フォーム
 */
import type { FC } from "react";
import { FormProvider, type UseFormReturn } from "react-hook-form";
import { InputUI } from "../../components/rhfs/Input";
import { TextareaUI } from "../../components/rhfs/Textarea";
import { Button } from "../../components/ui/button";

export interface OnboardingFormValues {
  name: string;
  description: string;
}

type OnboardingPageProps = {
  methods: UseFormReturn<OnboardingFormValues>;
  onSubmit: (values: OnboardingFormValues) => void;
  isSubmitting: boolean;
  error?: string;
};

export const OnboardingPage: FC<OnboardingPageProps> = ({
  methods,
  onSubmit,
  isSubmitting,
  error,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200">
      <div className="card w-full max-w-lg bg-base-100 shadow-xl">
        <div className="card-body">
          <h1 className="card-title text-2xl justify-center mb-2">
            Strix Search へようこそ
          </h1>
          <p className="text-center text-base-content/70 mb-6">
            はじめに、テナントを作成してください。
            <br />
            テナントはチームやプロジェクトの単位として利用できます。
          </p>

          <FormProvider {...methods}>
            <form
              onSubmit={methods.handleSubmit(onSubmit)}
              className="space-y-4"
            >
              <InputUI
                registerName="name"
                label="テナント名"
                placeholder="例: 株式会社サンプル"
                required
              />

              <TextareaUI
                registerName="description"
                label="説明（任意）"
                placeholder="テナントの説明を入力してください"
                rows={3}
              />

              {error && (
                <div className="alert alert-error">
                  <span>{error}</span>
                </div>
              )}

              <div className="card-actions justify-center mt-6">
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full"
                >
                  {isSubmitting ? (
                    <span className="loading loading-spinner loading-sm" />
                  ) : (
                    "作成して始める"
                  )}
                </Button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};
